import { render, staticRenderFns } from "./ModalReview.vue?vue&type=template&id=7af2f85e&"
import script from "./ModalReview.vue?vue&type=script&lang=js&"
export * from "./ModalReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports